import { DocumentTaxes } from 'modules/Documents/models/document';
import { VerifactuInvoice } from 'modules/Documents/models/verifactuInvoice';
import { formatTaxKey, TaxKey, TaxType } from 'modules/Taxes';

export const normalizeVerifactuTaxesToDocumentTaxes = (
  verifactu: VerifactuInvoice
): DocumentTaxes[] => {
  return verifactu.taxLines.map((taxLine): DocumentTaxes => {
    const key: TaxKey = taxLine?.nonTaxableTaxType
      ? (taxLine.nonTaxableTaxType as TaxKey)
      : formatTaxKey(taxLine.taxType as TaxType, taxLine.taxRate);

    return {
      amount: taxLine.taxAmount,
      base: taxLine.taxBase,
      key,
      percentage: taxLine.taxRate,
      sales_eq_tax: taxLine.equivalenceSurchargeAmount || 0,
      sales_eq_tax_percentage: taxLine.equivalenceSurchargeRate || 0,
      type: taxLine.taxType as TaxType,
    };
  });
};
